import options from './copyable-input.component';

export default {
    selector: 'dtCopyableInput',
    options
};
